__turbopack_context__.v({
  "kurboBtn": "styles-module-scss-module__7iJeZq__kurboBtn",
  "kurboWave": "styles-module-scss-module__7iJeZq__kurboWave",
  "sidebar": "styles-module-scss-module__7iJeZq__sidebar",
  "signInFlash": "styles-module-scss-module__7iJeZq__signInFlash",
  "toolbar": "styles-module-scss-module__7iJeZq__toolbar",
  "toolbarIcon": "styles-module-scss-module__7iJeZq__toolbarIcon",
  "toolbarIconWrap": "styles-module-scss-module__7iJeZq__toolbarIconWrap",
  "toolbarLabel": "styles-module-scss-module__7iJeZq__toolbarLabel",
  "toolbarToggle": "styles-module-scss-module__7iJeZq__toolbarToggle",
  "toolbarToggleKnob": "styles-module-scss-module__7iJeZq__toolbarToggleKnob",
});
